import React from 'react';
import HelpArticle from '../../components/help/HelpArticle';

const FirstBooking: React.FC = () => {
  const content = (
    <>
      <h2>Foretag din første booking</h2>
      <p>
        Er du klar til at leje dit første værktøj? Her er en trin-for-trin guide til at gennemføre din første booking på DoMore.
      </p>

      <h3>Trin 1: Find det værktøj du skal bruge</h3>
      <p>
        Brug søgefunktionen eller gennemse kategorier for at finde det værktøj, du har brug for. Se "Find det rigtige værktøj" artiklen for flere detaljer.
      </p>

      <h3>Trin 2: Vælg dine datoer</h3>
      <p>
        På værktøjets side kan du se tilgængelighedskalenderen. Vælg:
      </p>
      <ul>
        <li><strong>Startdato:</strong> Hvornår vil du hente værktøjet</li>
        <li><strong>Slutdato:</strong> Hvornår vil du returnere det</li>
      </ul>
      <p>
        Prisen beregnes automatisk baseret på antallet af dage. Hvis værktøjet ikke er tilgængeligt på dine ønskede datoer, prøv andre datoer eller find et lignende værktøj.
      </p>

      <h3>Trin 3: Send booking anmodning</h3>
      <p>
        Klik på "Book værktøj" knappen. Du kan tilføje en besked til ejeren med:
      </p>
      <ul>
        <li>Hvad du skal bruge værktøjet til</li>
        <li>Spørgsmål om afhentning</li>
        <li>Særlige behov eller ønsker</li>
      </ul>

      <h3>Trin 4: Vent på bekræftelse</h3>
      <p>
        Ejeren modtager din anmodning og vil enten:
      </p>
      <ul>
        <li><strong>Acceptere:</strong> Din booking er bekræftet!</li>
        <li><strong>Afvise:</strong> Værktøjet er måske ikke tilgængeligt alligevel</li>
        <li><strong>Sende en besked:</strong> Med spørgsmål eller alternative forslag</li>
      </ul>
      <p>
        Du modtager en notifikation, når ejeren har svaret.
      </p>

      <h3>Trin 5: Aftale afhentning</h3>
      <p>
        Når bookingen er bekræftet, skal I aftale:
      </p>
      <ul>
        <li>Præcis tidspunkt for afhentning</li>
        <li>Adresse eller mødested</li>
        <li>Hvordan betalingen skal håndteres</li>
        <li>Hvad der følger med værktøjet</li>
      </ul>
      <p>
        Brug chatfunktionen til at koordinere detaljerne.
      </p>

      <h3>Trin 6: Hent værktøjet</h3>
      <p>
        På afhentningsdagen:
      </p>
      <ul>
        <li>Mød til tiden</li>
        <li>Inspicér værktøjet for skader</li>
        <li>Få instruktioner i brugen hvis nødvendigt</li>
        <li>Tag billeder af værktøjets tilstand</li>
        <li>Håndter betalingen som aftalt</li>
      </ul>

      <h3>Trin 7: Brug og returner</h3>
      <p>
        Brug værktøjet som aftalt og returner det til tiden i samme stand. Husk at rengøre værktøjet før returnering.
      </p>

      <h3>Trin 8: Efterlad en anmeldelse</h3>
      <p>
        Efter lejeperioden kan du bedømme din oplevelse. Dette hjælper andre brugere og belønner gode udlejere.
      </p>
    </>
  );

  return (
    <HelpArticle
      title="Foretag din første booking"
      category="Kom i gang"
      content={content}
      relatedArticles={[
        { title: 'Bookingprocessen forklaret', link: '/help/booking-process' },
        { title: 'Afhentning og returnering', link: '/help/pickup-return' },
      ]}
    />
  );
};

export default FirstBooking;
